var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMortgage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0028 28.0472L22.8008 25.0003C22.7258 24.8104 22.5508 24.6875 22.3566 24.6875H19.9526C19.7583 24.6875 19.5833 24.8104 19.5083 25.0003L18.3063 28.0472C18.2448 28.2036 18.2611 28.3823 18.3505 28.5235C18.44 28.6657 18.59 28.75 18.7506 28.75H23.5586C23.7191 28.75 23.8692 28.6657 23.9586 28.5235C24.048 28.3823 24.0644 28.2036 24.0028 28.0472Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8484 28.0472L26.6492 25.0003C26.5742 24.8114 26.3992 24.6875 26.205 24.6875H23.7943C23.6548 24.6875 23.5269 24.7525 23.4375 24.8581L24.5924 27.7872C24.7155 28.101 24.6972 28.4484 24.5606 28.75H27.4041C27.5647 28.75 27.7147 28.6657 27.8041 28.5235C27.8936 28.3834 27.9099 28.2036 27.8484 28.0472Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9286 23.3089L24.7266 20.262C24.6516 20.0721 24.4766 19.9492 24.2823 19.9492H21.8783C21.6841 19.9492 21.5091 20.0721 21.4341 20.262L20.2321 23.3089C20.1705 23.4653 20.1869 23.6441 20.2763 23.7852C20.3657 23.9264 20.5158 24.0117 20.6763 24.0117H25.4843C25.6449 24.0117 25.7949 23.9274 25.8844 23.7852C25.9738 23.6441 25.9901 23.4663 25.9286 23.3089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7013 15.5469H20.84L21.9488 14.6094C22.3267 14.2916 22.4671 13.7746 22.3075 13.2922C22.1488 12.8118 21.7334 12.5 21.2516 12.5H15.2897C14.8079 12.5 14.3925 12.8118 14.2329 13.2932C14.0733 13.7746 14.2137 14.2916 14.5916 14.6094L15.7013 15.5469Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4186 27.6561L18.6206 24.6083C18.7523 24.2741 18.9927 24.0222 19.2822 23.8608C19.21 23.55 19.2216 23.2209 19.3418 22.9173L20.5438 19.8694C20.7688 19.2996 21.2909 18.9319 21.8756 18.9319H22.5968C22.117 18.0291 21.5487 17.2064 20.9265 16.5625H15.6127C13.8616 18.3764 12.5 21.5604 12.5 24.1776C12.5 26.4526 13.6395 28.7479 16.1858 28.7479H17.3897C17.2724 28.3965 17.2792 28.0076 17.4186 27.6561Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMortgage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_mortgage.dfe7226a69d4fa6584be0865cdda6cec.svg";